import * as types from './types'
import http from '@/Plugins/api'

export default {
  setPager({ commit }, data) {
    commit(types.SET_PAGER, data)
  },
  setChecked({ commit }, data) {
    commit(types.SET_CHECKED, data)
  },
  setToken({ commit }, token) {
    commit(types.SET_TOKEN, token)
  },
  setProfile({ commit }, profile) {
    commit(types.SET_PROFILE, profile)
  },
  setLogout({ commit }) {
    commit(types.SET_LOGOUT)
  },
  setUserData({ commit }, data) {
    commit(types.SET_USER_DATA, data)
  },
  resetUser({ commit }) {
    commit(types.RESET_USER)
  },
  setHover({ commit }, data) {
    commit(types.SET_HOVER, data)
  },
  setSelected({ commit }, data) {
    commit(types.SET_SELECTED, data)
  },
  setCurrent({ commit }, data) {
    commit(types.SET_CURRENT, data)
  },
  setRoles({ commit }, data) {
    commit(types.SET_ROLES, data)
  },
  async getRoles({ commit }, data) {
    const r = await http.get(`v2/users/roles/${data.id}`)
    commit(types.SET_USER_ROLES, r.data.data)
    return r.data.data
  },
  async getUsers({ commit }, searchOptions) {
    const r = await http.get(`v2/users`, {
      params: searchOptions,
    })
    commit(types.SET_USERS, r.data.data)
    return r.data.data
  },
  async getUserHighlight({ commit }, id) {
    const r = await http.get(`v2/users/highlight/${id}`)
    commit(types.SET_USER_HIGHLIGHT, r.data.data)
    return r.data.data
  },
  async getUser({ commit }, id) {
    const r = await http.get(`v2/users/edit/${id}`)
    commit(types.SET_USER, r.data.data)
    return r.data.data
  },
  async checkForExisting({ commit }, data) {
    const r = await http.post(`v2/users/existing`, data)
    return r.data.data
  },
  async saveUser({ commit }, data) {
    let r = null
    if (data.id === null) {
      r = await http.post('v2/users', data)
    } else {
      r = await http.post('v2/users/update', data)
    }
    commit(types.SET_PASSWORD)
    return r.data.data
  },
  async saveRoles({ commit }, data) {
    const r = await http.post(`v2/users/roles`, data)
    return r.data.data
  },
  async savePassword({ commit }, data) {
    const r = await http.post(`v2/users/password`, data)
    commit(types.SET_PASSWORD)
    return r.data.data
  },
  async removeUser({ commit }, id) {
    const r = await http.delete(`v2/users/${id}`)
    return r.data.data
  },
  async getUserOrganizations({ commit }, id) {
    const r = await http.get(`v2/users/organizations/${id}`)
    commit(types.SET_USER_ORGANIZATIONS, r.data.data)
    return r.data.data
  },
  async changeUserOrganization({ commit }, data) {
    const r = await http.post(`v2/users/changeorganization`, data)
    return r.data.data
  },
  async findUsers({ commit }, options) {
    const r = await http.get(`v2/users/autocomplete`, {
      params: options,
    })
    commit(types.SET_FOUND_USERS, r.data.data)
    return r.data.data
  },
  async saveBioInfo({ commit }, data) {
    const r = await http.post(`v2/users/savebioinfo`, data)
    commit(types.UPDATE_USER_DATA, r.data.data)
    return r.data.data
  },
  resetNote({ commit }) {
    commit(types.RESET_USER_NOTE)
  },
  getNote({ commit }, id) {
    commit(types.SET_USER_NOTE, id)
  },
  setNoteData({ commit }, data) {
    commit(types.SET_USER_NOTE_DATA, data)
  },
  async getNotes({ commit }, id) {
    const r = await http.get(`v2/usernotes/${id}`)
    commit(types.SET_USER_NOTES, r.data.data)
    return r.data.data
  },
  async saveNote({ commit }, data) {
    const r = await http.post(`v2/usernotes`, data)
    return r.data.data
  },
  async removeNote({ commit }, id) {
    const r = await http.delete(`v2/usernotes/${id}`)
    return r.data.data
  },
  async deleteUser({ commit }, id) {
    const r = await http.delete(`v1/account/${id}`)
    return r.data.data
  },
  async clearIntended({ commit }) {
    const r = await http.post(`clear-intended-url`)
  },
}
